var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesignation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9008 11.0856L5.69775 18.2886",
    stroke: "#0074B2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1997 11.0856H12.9008V13.7867",
    stroke: "#0074B2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39883 20.2354C9.50229 20.7176 10.7188 20.9897 12.0003 20.9897C16.9734 20.9897 21.0041 16.9591 21.0041 11.986C21.0041 7.01292 16.9734 2.98224 12.0003 2.98224C7.02726 2.98224 2.99658 7.01292 2.99658 11.986C2.99658 13.2805 3.2747 14.508 3.7669 15.6205",
    stroke: "#0074B2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1 17.3082C11.3931 17.3592 11.6933 17.3882 12.0004 17.3882C14.9836 17.3882 17.4026 14.9692 17.4026 11.986C17.4026 9.00275 14.9836 6.58374 12.0004 6.58374C9.01715 6.58374 6.59814 9.00275 6.59814 11.986C6.59814 12.2931 6.62716 12.5932 6.67818 12.8864",
    stroke: "#0074B2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignation);
export default __webpack_public_path__ + "static/media/designation.65310d3bf36d07753d9753f2f6b52699.svg";
export { ForwardRef as ReactComponent };